module.exports = __webpack_public_path__ + "static/media/view canteen.be76dbc2.svg";